import React, { useState, useEffect, useContext } from 'react';
import { Container, Row, Col } from 'reactstrap';
import Progress from '../../components/shared/StatusProgress/Progress';
import moment from 'moment';
import ClaimDetails from '../../screens/ProgressClaimDetails/ClaimDetails';
import styles from '../../screens/Vendor/Apple/ClaimOverview.module.css';
import classNames from 'classnames';
import { useLocation, useRouteMatch } from 'react-router-dom';
import { phoneFormat } from '../../components/shared/util';
import ClaimInformation from '../ProgressClaimDetails/ClaimInformation';
import momenttz from 'moment-timezone';
import useTranslation from '../../components/contexts/LanguageTranslation/useTranslation';
import { ContractContext } from '../../components/contexts/ContractContext';
import PageLoading from '../../components/shared/PageLoading/PageLoading';

let orderLast = 'order-last';
let orderLGFirst = 'order-lg-first';
let overviewBody = styles.overviewBody;
let mrAuto = 'mr-auto';
const timezoneArea = momenttz.tz.guess();

/*
 * REMOVE LATER - TO TEST TOGGLING BETWEEN MULTIPLE VIEWS.
 * ROUTE TO HWA /detailsoverview/?type=buyout
 * USE buyout, replacement,appointment, hireservicer(EVENTS)
 */
function useQuery() {
    return new URLSearchParams(useLocation().search);
}

export const getEventTypeNameById = (eventTypeId) => {
    switch (eventTypeId) {
        case 1:
            return 'Repair';
        case 2:
            return 'Replacement';
        case 3:
            return 'Reimbursement';
        case 4:
            return 'Re-dispatch';
        case 5:
            return 'Warranty of work';
        case 6:
            return 'Buyout';
        case 7:
            return 'Triage';
        case 8:
            return 'Setup';
        default:
            return null;
    }
};

export function DetailsOverview(props) {
    const context = useContext(ContractContext);
    const { translations } = useTranslation('screens/PlanOverview/DetailsOverview');

    const [stepsInfo, setStepsInfo] = useState([]);
    const urlPath = useRouteMatch('/ReimbursementRequestInvoice/:clientId/:token');
    let [token] = useState(urlPath?.params?.token);
    let [clientId] = useState(urlPath?.params?.clientId);

    const [claim, setClaim] = useState(props?.location?.claim);
    const [contract, setContract] = useState({});
    const [contractAsset, setContractAsset] = useState({});
    const [coverage, setCoverage] = useState({});
    const [event, setEvent] = useState({});
    const [fetchingData, setFetchingData] = useState(false);
    const [refreshTokenData, setRefreshTokenData] = useState(false);
    let type = claim?.eventType || getEventTypeNameById(event?.eventTypeId)?.toLowerCase();
    let servicerHired = claim?.servicerOptionSelected == 'hireservicer' ? true : false;
    type = servicerHired ? 'hireservicer' : type;
    let approvedStatus = [1, 6, 9];
    let completedStatus = [6, 9];
    const partyInformation = claim?.partyModel || contract?.party;
    let authorizedAmount = claim?.authorizedAmount;
    const claimStatusName = claim?.claimStatusName || claim?.claimStatusModel?.claimStatusName;

    const portfolioDealer = claim?.historicalPortfolioClaimsFlag === 1 ? true : false;

    const getLocalTimeZoneString = (datestr, timezone) => {
        const currentTimeZone = momenttz.tz.guess();
        //If timezone provided format using that timezone, if no timezone provided we format using users local timezone
        const localDateString = timezone ? momenttz.tz(datestr, timezone) : momenttz.parseZone(datestr);

        return localDateString.tz(currentTimeZone).format('hh:mm A z, MMMM DD, YYYY');
    };

    /*
     * CLAIM STATUS STEPS BASED ON EVENT TYPE
     */
    const getSteps = () => {
        const eventType = portfolioDealer ? 'portfolioDealer' : type;
        let steps = [];
        switch (eventType) {
            case 'portfolioDealer':
                steps = [
                    {
                        name: 'Claim Received',
                        style:
                            claimStatusName === 'Open'
                            || claimStatusName === 'Closed with amount'
                            || claimStatusName === 'Closed without payment'
                                ? 'completed'
                                : 'active',
                        date:
                            claim?.claimSetupDateOverview != null
                                ? getLocalTimeZoneString(claim?.claimSetupDateOverview)
                                : null
                    },
                    {
                        name: 'Service Completed',
                        style: claimStatusName === 'Closed with amount' ? 'completed' : 'active',
                        date: null
                    }
                ];
                return steps;
            case 'buyout':
                steps = [
                    {
                        name: 'Claim Received',
                        style: claim?.claimSetupDate != null ? 'completed' : 'active',
                        date:
                            claim?.claimSetupDate != null
                                ? getLocalTimeZoneString(claim?.claimSetupDateOverview)
                                : 'N/A'
                    },
                    {
                        name: 'Claim Approved',
                        style: approvedStatus.includes(claim?.eventStatusId) ? 'completed' : 'active',
                        date: null
                    },
                    {
                        name: 'Reimbursement Sent',
                        style: 'active',
                        date: null
                    }
                ];
                return steps;

            case 'appointment':
            case 'wow':
                steps = [
                    {
                        name: 'Claim Received',
                        style:
                            claim?.claimSetupDateOverview != null || claim?.claimSetupDate != null
                                ? 'completed'
                                : 'active',
                        date:
                            claim?.claimSetupDateOverview != null
                                ? getLocalTimeZoneString(claim?.claimSetupDateOverview)
                                : claim?.claimSetupDate != null
                                  ? getLocalTimeZoneString(claim?.claimSetupDate)
                                  : 'N/A'
                    },
                    {
                        name: 'Claim Approved',
                        style: approvedStatus.includes(claim?.eventStatusId) ? 'completed' : 'active',
                        date: null
                    },
                    {
                        name: 'Scheduled Appointment',
                        style: claim?.scheduledAppointment != null ? 'completed' : 'active',
                        date:
                            claim?.scheduledAppointment != null
                                ? momenttz(claim?.scheduledAppointment)
                                      .tz(timezoneArea)
                                      .format('hh:mm A z, MMMM DD, YYYY')
                                : ''
                    },
                    {
                        name: 'Service In Progress',
                        style:
                            claim?.scheduledAppointment != null
                            && (approvedStatus.includes(claim?.eventStatusId) || claim?.accepted)
                            && moment(claim?.scheduledAppointment).format('MMMM Do, YYYY')
                                <= moment(Date()).format('MMMM Do, YYYY')
                                ? 'completed'
                                : 'active',
                        date: null,
                        id: 'deliveryId'
                    },
                    {
                        name: 'Service Completed',
                        style: completedStatus.includes(claim?.eventStatusId) ? 'complete' : 'active',
                        date: null
                    }
                ];
                return steps;

            case 'replacement':
                steps = [
                    {
                        name: 'Claim Received',
                        style: claim?.claimSetupDate != null ? 'completed' : 'active',
                        date:
                            claim?.claimSetupDate != null
                                ? getLocalTimeZoneString(claim?.claimSetupDateOverview)
                                : 'N/A'
                    },
                    {
                        name: 'Claim Approved',
                        style: approvedStatus.includes(claim?.eventStatusId) ? 'completed' : 'active',
                        date: null
                    },
                    {
                        name: 'Replacement Ordered',
                        style: 'active',
                        date: null
                    }
                ];
                return steps;

            case 'hireservicer':
                steps = [
                    {
                        name: 'Claim Received',
                        style: claim?.claimSetupDate != null ? 'completed' : 'active',
                        date:
                            claim?.claimSetupDate != null
                                ? getLocalTimeZoneString(claim?.claimSetupDateOverview)
                                : 'N/A'
                    },
                    {
                        name: 'Claim Approved',
                        style: approvedStatus.includes(claim?.eventStatusId)
                            ? 'completed'
                            : claimStatusName == 'Open'
                              ? 'completed'
                              : 'active',
                        date: null
                    },
                    {
                        name: 'Hire Your Own Servicer',
                        style: servicerHired ? 'completed' : 'active',
                        date: null
                    },
                    {
                        name: 'Invoice Submitted',
                        style: claim?.invoicesCount > 0 ? 'completed' : 'active',
                        date: null
                    },
                    {
                        name: 'Reimbursement Mailed',
                        style:
                            servicerHired
                            && claim?.invoicesCount > 0
                            && (claimStatusName == 'Closed without payment'
                                || claimStatusName == 'Closed with amount'
                                || claimStatusName == 'Closed')
                                ? 'completed'
                                : 'active',
                        date: null
                    }
                ];
                return steps;

            case 'reimbursement':
                steps = [
                    {
                        name: 'Claim Received',
                        style: claim?.claimSetupDate != null ? 'completed' : 'active',
                        date:
                            claim?.claimSetupDate != null
                                ? getLocalTimeZoneString(claim?.claimSetupDateOverview)
                                : 'N/A'
                    },
                    {
                        name: 'Claim Approved',
                        style: approvedStatus.includes(claim?.eventStatusId || event?.eventStatusId)
                            ? 'completed'
                            : claimStatusName == 'Open'
                              ? 'completed'
                              : 'active',
                        date: null
                    },
                    {
                        name: 'Hire Your Own Servicer',
                        style: 'completed',
                        date: null
                    },
                    {
                        name: 'Invoice Submitted',
                        style: event?.isRoughFinish
                            ? event?.isEventInvoices
                                ? 'completed'
                                : 'active'
                            : claim?.invoicesCount > 0
                              ? 'completed'
                              : 'active',
                        date: null
                    },
                    {
                        name: 'Reimbursement Mailed',
                        style: event?.isRoughFinish
                            ? event?.isPaidInvoices
                                ? 'completed'
                                : 'active'
                            : servicerHired
                                && claim?.invoicesCount > 0
                                && (claimStatusName == 'Closed without payment'
                                    || claimStatusName == 'Closed with amount'
                                    || claimStatusName == 'Closed')
                              ? 'completed'
                              : 'active',
                        date: null
                    }
                ];
                return steps;

            default:
                steps = [
                    {
                        name: 'Claim Received',
                        style: claim?.claimSetupDate != null ? 'completed' : 'active',
                        date:
                            claim?.claimSetupDate != null ? getLocalTimeZoneString(claim?.claimSetupDateOverview) : null
                    },
                    {
                        name: 'Claim Approved',
                        style: approvedStatus.includes(claim?.eventStatusId) ? 'completed' : 'active',
                        date: null
                    }
                ];
                return steps;
        }
    };

    const verifyToken = async () => {
        try {
            const response = await fetch(`/vendor/Reimbursement/verifyReimbursementToken/${token}/${clientId}`);
            if (response.ok) {
                const result = await response.json();
                setClaim(result.claimModel);
                setContract(result.contractModel);
                setEvent(result.eventModel);
                context?.updateContract(result.contractModel);
                context?.updateClientId(result.contractModel?.clientId);
                const tempContractAsset = result?.contractModel?.contractAssetModel?.find(
                    (ca) => ca?.contractAssetId === result?.claimModel?.contractAssetId
                );
                setContractAsset(tempContractAsset);
                setCoverage(
                    tempContractAsset?.contractAssetCoverageModel?.find(
                        (coverage) =>
                            coverage?.contractAssetCoverageId
                            === result?.eventModel?.featureClaimModel?.contractAssetCoverageId
                    )
                );
                setFetchingData(false);
                setRefreshTokenData(false);
            } else {
                console.error(`Status: ${response.status}`);
            }
        } catch (error) {
            console.error(error);
        }
    };

    const handleTokenDataRefresh = () => {
        setRefreshTokenData(true);
    };

    useEffect(() => {
        const step = getSteps();
        setStepsInfo(step);
    }, [props, type]);

    useEffect(() => {
        if (urlPath) {
            //If URL matches we verify the token to retrieve data
            setFetchingData(true);
            verifyToken();
        }
    }, []);

    useEffect(() => {
        if (urlPath && refreshTokenData) {
            //If URL matches we verify the token to retrieve data if update is requested
            verifyToken();
        }
    }, [refreshTokenData]);

    const assetInformation = {
        asset: claim?.assetName
    };

    function getProductName(claim) {
        let brand = claim?.brand;
        let productName = '';
        if (brand == 'Unknown' || brand == 'UNK' || typeof brand == 'undefined') {
            productName = claim?.assetName;
        } else {
            productName = `${brand} ${claim?.assetName}`;
        }
        return productName;
    }

    function getAppointentTime(time) {
        switch (time) {
            case '08:00:00':
                return '8 AM - Noon';
            case '12:00:00':
                return 'Noon - 5 PM';
            default:
                return '8 AM - 5 PM';
        }
    }
    const productInformation = [
        {
            name: 'Product',
            value: getProductName(claim)
        },
        {
            name: 'Description',
            value: claim?.assetDescription
        },
        {
            name: 'Model',
            value: claim?.modelNumber
        },
        {
            name: 'Serial',
            value: claim?.serialNumber
        },
        {
            name: 'Purchase Date',
            value:
                claim?.purchaseDate != null
                    ? moment(claim?.purchaseDate).format('MM/DD/YYYY')
                    : claim?.assetPurchaseDate != null
                      ? moment(claim?.assetPurchaseDate).format('MM/DD/YYYY')
                      : null
        }
    ];

    const claimDetails = [
        {
            name: 'Symptom',
            value: claim?.symptom
        },
        {
            name: 'Incident Date',
            value:
                claim?.incidentDate != null
                    ? moment(claim?.incidentDate).format('MM/DD/YYYY')
                    : claim?.lossDate != null
                      ? moment(claim?.lossDate).format('MM/DD/YYYY')
                      : null
        },
        {
            name: 'Incident Description',
            value: claim?.incidentDescription
        }
    ];

    const serviceAppointment = [
        {
            name: 'Date',
            value: claim?.appointmentDate != null ? moment(claim?.appointmentDate).format('dddd, MMMM DD, YYYY') : null
        },
        {
            name: 'Time',
            value:
                claim?.appointmentTime != null
                    ? getAppointentTime(claim?.appointmentTime) + ' ' + momenttz.tz(timezoneArea).format('z')
                    : null
        },
        {
            name: 'Servicer',
            value: typeof claim?.servicerPhone == 'undefined' ? null : claim?.servicerName
        },
        {
            name: 'Servicer Phone',
            value:
                typeof claim?.servicerPhone == 'undefined' || claim?.servicerPhone == null
                    ? null
                    : phoneFormat(claim?.servicerPhone)
        }
    ];

    if (type === 'buyout') {
        //list.push("Reimbursement Amount: $xx.xxx");
    }

    return (
        <Container className='contentWrapper'>
            {!fetchingData ? (
                <Row>
                    <Col
                        lg='7'
                        className={classNames(overviewBody, mrAuto, orderLast, orderLGFirst)}
                    >
                        <ClaimInformation
                            {...props}
                            clientId={contract?.clientId}
                            claim={claim}
                            event={event}
                            contractAsset={contractAsset}
                            assetCoverage={coverage}
                            serviceAppointment={serviceAppointment}
                            assetInformation={assetInformation}
                            claimDetails={claimDetails}
                            productInformation={productInformation}
                            eventType={type}
                            partyInformation={partyInformation}
                            portfolioDealer={portfolioDealer}
                            handleTokenDataRefresh={handleTokenDataRefresh}
                            updatingTokenData={refreshTokenData}
                        />
                    </Col>
                    <Progress steps={stepsInfo} />
                </Row>
            ) : (
                <PageLoading
                    text={''}
                    height={500}
                />
            )}
        </Container>
    );
}
